// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

var VueCookie = require('vue-cookie');
Vue.use(VueCookie);

Vue.config.productionTip = false

/* CSS */
require('../node_modules/intro.js/minified/introjs.min.css')

/* JS */
require('../node_modules/intro.js/minified/intro.min.js')

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js